const THEME_STORAGE_KEY = "umkm-pos-theme";

export const getStoredTheme = () => localStorage.getItem(THEME_STORAGE_KEY) || "light";

export const applyTheme = (theme) => {
  const normalizedTheme = theme === "dark" ? "dark" : "light";
  document.documentElement.setAttribute("data-bs-theme", normalizedTheme);
  document.body.setAttribute("data-bs-theme", normalizedTheme);
  localStorage.setItem(THEME_STORAGE_KEY, normalizedTheme);

  return normalizedTheme;
};

export const toggleTheme = () => applyTheme(getStoredTheme() === "dark" ? "light" : "dark");
